const state = {
  isDark: localStorage.getItem('darkMode') === 'true'
}

const mutations = {
  SET_DARK_MODE(state, value) {
    state.isDark = value
    localStorage.setItem('darkMode', value)
    if (value) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }
}

const actions = {
  toggleDarkMode({ commit, state }) {
    commit('SET_DARK_MODE', !state.isDark)
  },
  initDarkMode({ state }) {
    if (state.isDark) {
      document.documentElement.classList.add('dark')
    }
  }
}

const getters = {
  isDarkMode: state => state.isDark
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
